let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jypkn")).then(() => parcelRequire('iyEu6'));